export const route = {
  chat: '/chat',
  moment: '/m',
  
}
